
<style type="text/css" lang="scss" scoped>
    @import '../../../static/css/reset.scss';

    #footerBig {
    	width:100%;
    	height: 224px;
    	background-color: #364983;
        clear: both;
        #footerSma{
            width:1120px;
            margin:0 auto;
            padding-top:20px;
            padding-bottom: 15px;
            font-size:16px;
            color:#fff;
            .footerLogo{
                float:left;
                cursor: pointer;
                padding-top: 20px;
                .logoIcon{
                    width: 146px;
                    height: 69px;
                    background-image: url('./images/footer-logo.png');
                    background-size: cover;
                }

            }
            .hrefBox{
                float:left;
                width:534px;
                height:66px;
                padding-top: 20px;
                margin: 0 0 0 118px;
                a{
                   color:rgba(255,255,255,0.60);
                   float: left;
                   width: 178px;
                   &.down{
                       line-height: 70px;
                   }
                   &.up{
                       line-height: initial;
                   }
                   &:hover{
                       color: #fff;
                   }

                }
            }
            .careUs{
                float:left;
                .careLeft{
                    float:left;
                    // margin:0 50px;
                    p{
                        clear: both;
                        line-height:54px;
                    }
                    .sina{
                        display:inline-block;
                        width:29px;
                        height:24px;
                        float:left;
                        margin-top: 20px;
                        margin-left:25px;
                        margin-right:30px;
                        cursor:pointer;
                        background-image: url('./images/sina.png');
                    }
                    .tencent{
                        display:inline-block;
                        width:35px;
                        height:29px;
                        margin-top: 20px;
                        float:left;
                        cursor:pointer;
                        background-image: url('./images/tencent.png');
                    }
                }
                .careRight{
                    float:left;
                    margin-left: 48px;
                    width:100px;
                    height:100px;
                    background-image: url('./images/code.png');
                    background-size: 100px 100px;
                }
            }
            .hr{
                clear:both;
                position: relative;
                width:100%;
                height:20px;
                margin-bottom:12px;
                &:after{
                    position: absolute;
                    content: '';
                    left: 0px;
                    right: 0px;
                    bottom: 0px;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.32);
                }

            }
            .footerCopy{
                font-size:12px;
                text-align:center;
                line-height:26px;
                vertical-align: middle;
            }
        }
    }

</style>

<template>
	<div id="footerBig">
		<div id="footerSma">
			<div class="footerLogo" v-on:click="toIndex">
                <p class="logoIcon"></p>
                <p class="logoMsg"></p>
            </div>
            <div class="hrefBox">
                <a v-for="(el,index) in hrefList" :href="el.url" target="_blank"
                   :class="(index == 3 || index == 4 || index == 5)? 'down' : 'up'" :key="index">{{el.name}}</a>
            </div>
            <div class="careUs">
                <div class="careLeft">
                    <span class="sina" v-on:click="toSina"></span>
                    <span class="tencent" v-on:click="toTencent"></span>
                    <p>在这里关注我们的动向</p>
                </div>
                <div class="careRight"></div>
            </div>
            <div class="hr"></div>
            <p class="footerCopy">© COPYRIGHT {{footerNowYear}} — ALL RIGHTS RESERVED. 北京神州同道智能信息技术有限公司 京ICP备19056818号</p>
            <p class="footerCopy">
                <img style="width: 16px;height: 16px;margin-right: 5px; position:relative; top:3px" src="https://www.forex.com.cn/dist/static/images/beian.png" alt="">
                <span>京公网安备 11010502030319号</span>
            </p>
		</div>
	</div>
</template>

<script>
    export default Vue.component('ui-footer',{
    	data:function(){
    		return {
                hrefList:window.PAGE_DATA.commonData.footer || [],
                footerNowYear:null
    		}
    	},
        mounted:function(){
            this.footerNowYear = new Date().getFullYear();
        },
        methods:{
            toIndex:function(){
                window.open('http://www.forex.com.cn/');
            },
            toSina:function(){
                window.open('http://weibo.com/');
            },
            toTencent:function(){
                window.open('http://t.qq.com/forexcomcn/');
            }
        }
    })

</script>



// WEBPACK FOOTER //
// src/components/common/footer/footer.vue